import { RadioInput } from './RadioInput'
import { withRadioInput } from './withRadioInput'

export const ConnectedRadioInput = withRadioInput(RadioInput)

export { ConnectedRadioInput as RadioInput }
